/**
 * 「나」 탭 사주 · 별자리 정보 지우기 (처리방침 11장, DEV-07z4 2 · D102).
 * 한 번 더 묻고 지움: 생년월일 · 계산 결과 · 별 계산이 같이 지워지고, 다시 입력할 때까지 멤버가 먼저 생일을 묻지 않음
 */
import { useState } from 'react';
import { errorMessageOf } from '../../api/client.js';
import * as meApi from '../../api/me.js';

export function SajuDelete({ onDeleted }) {
    const [asking, setAsking] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    async function remove() {
        setBusy(true);
        setError(null);
        try {
            await meApi.deleteMySaju();
            setAsking(false);
            onDeleted();
        } catch (failure) {
            setError(errorMessageOf(failure, '지우지 못했어요. 잠시 후 다시 해 주세요.'));
        } finally {
            setBusy(false);
        }
    }

    if (!asking) {
        return (
            <button type="button" onClick={() => setAsking(true)} className="h-10 px-3 text-[15px] text-text-secondary">
                지우기
            </button>
        );
    }
    return (
        <span className="flex flex-wrap items-center gap-2">
            <span className="text-caption text-text-secondary">생일과 풀이 계산이 같이 지워져요.</span>
            <button
                type="button"
                disabled={busy}
                onClick={remove}
                className="h-9 rounded-lg bg-error px-3 text-[14px] font-semibold text-white disabled:opacity-40"
            >
                지울게요
            </button>
            <button type="button" onClick={() => setAsking(false)} className="h-9 px-2 text-[14px] text-text-secondary">
                취소
            </button>
            {error ? (
                <span role="alert" className="w-full text-caption text-error">
                    {error}
                </span>
            ) : null}
        </span>
    );
}
